// Pure stream-markdown marker helpers shared by Snippet/Snippet.vue and Stream.vue
// (SonarQube dedup). Bodies moved byte-identical from the components; each component
// keeps its existing method names as one-line wrappers delegating here, so all
// onDownloadProgress call sites are unchanged. The eslint directive and //NOSONAR
// comments below were moved verbatim with the code they already covered.
/* eslint-disable no-useless-escape */

export function tokenizeCodeFences(_responseText) {
  _responseText = _responseText.replace(/(?:\\\\n|\\\n|\\n|\r\n|\r|\n)/g, "\n");


  _responseText = _responseText.replace(/(?: {6}\n| {5}\n| {4}\n| {3}\n| {2}\n| \n)/g, "\n");
  _responseText = _responseText.replace(/(?:\n {6}```|\n {5}```|\n {4}```|\n {3}```|\n {2}```|\n ```)/g, "\n```");

  _responseText = _responseText.replaceAll(/(?:\n```\n```\n\n)/g, "\n<||End||>\n<||EndMarkdown||>\n\n");
  _responseText = _responseText.replaceAll(/(?:\n```\n\n)/g, "\n<||End||>\n\n");

  _responseText = _responseText.replace(/(?:\n```\n```python|\n {3}```\n {3}```python)/g, "\n<||StarMarkdown||>\n<||StarPython||>");
  _responseText = _responseText.replace(/(?:\n```\n```javascript|\n {3}```\n {3}```javascript)/g, "\n<||StarMarkdown||>\n<||StarJavascript||>");

  _responseText = _responseText.replaceAll(/(?:\n```\n)/g, "\n<||StarAll||>\n");
  _responseText = _responseText.replaceAll(/(?:\n```python)/g, "\n<||StarPython||>");
  _responseText = _responseText.replaceAll(/(?:\n```javascript)/g, "\n<||StarJavascript||>");
  _responseText = _responseText.replaceAll(/(?:\n```markdown)/g, "\n<||StarMarkdown||>");
  return _responseText;
}

export function resolveEndMarker(Sp_RT, I_Sp_RT, Sp_Value, Sp_Value_Old) {
  for (let II_Sp_RT = I_Sp_RT - 1; II_Sp_RT > 0; II_Sp_RT--) {

    try {

      let Sp_Value_Old_Loop = Sp_RT[II_Sp_RT].split("||>");
      if (Sp_Value_Old.length > 1 && Sp_Value_Old_Loop.length > 1) {

        if (Sp_Value[0].includes("End") && Sp_Value_Old[0].includes("Star")) {
          let re_SVO = Sp_Value_Old[0].replace("Star", "End");
          Sp_RT[I_Sp_RT] = Sp_RT[I_Sp_RT].replace("End||>", re_SVO + "||>");
          break;
        }
        else if (Sp_Value[0].includes("End") && Sp_Value_Old[0].includes("End")
          && Sp_Value_Old_Loop[0].includes("Star") &&
          !Sp_Value_Old_Loop[0].includes(Sp_Value_Old[0].replace("End", "Star"))
        ) {
          let re_SVO = Sp_Value_Old_Loop[0].replace("Star", "End");
          Sp_RT[I_Sp_RT] = Sp_RT[I_Sp_RT].replace("End||>", re_SVO + "||>");
          break;
        }
        else {
          // no matching marker found
        }
      }
    } catch (e) { //NOSONAR
      // error intentionally ignored
    }
  }
}

export function resolveStarAllMarker(Sp_RT, I_Sp_RT, Sp_Value_Old) {
  let Sp_Value_New = Sp_RT[I_Sp_RT + 1].split("||>");
  if (Sp_Value_Old[0].includes("Star")
    && Sp_Value_New.length > 1 && Sp_Value_New[0].includes("Star")) {
    let re_SVO = Sp_Value_Old[0].replace("Star", "End");
    Sp_RT[I_Sp_RT] = Sp_RT[I_Sp_RT].replace("StarAll||>", re_SVO + "||>");
  }
}

export function joinMarkerSegments(Sp_RT) {
  for (let Iii_Sp_RT = 0; Iii_Sp_RT < Sp_RT.length; Iii_Sp_RT++) {
    if (Sp_RT[Iii_Sp_RT].includes("||>")) {
      Sp_RT[Iii_Sp_RT] = "<||" + Sp_RT[Iii_Sp_RT];
    }
  }
  return Sp_RT.join("");
}

export function expandMarkerTokens(_responseText) {
  _responseText = _responseText.replaceAll("<||StarMarkdown||>", "\n`````\n");
  _responseText = _responseText.replaceAll("<||EndMarkdown||>", "`````\n");

  _responseText = _responseText.replaceAll("<||StarAll||>", "```");
  _responseText = _responseText.replaceAll("<||EndAll||>", "```");


  _responseText = _responseText.replaceAll("<||StarJavascript||>", "```javascript");
  _responseText = _responseText.replaceAll("<||EndJavascript||>", "```");
  _responseText = _responseText.replaceAll("<||StarPython||>", "```python");
  _responseText = _responseText.replaceAll("<||EndPython||>", "```");


  _responseText = _responseText.replaceAll("<||Star||>", "```");
  _responseText = _responseText.replaceAll("<||End||>", "```");
  return _responseText;
}

export function resolveCodeMarkers(_responseText, Sp_RT) {
  for (let I_Sp_RT = 0; I_Sp_RT < Sp_RT.length; I_Sp_RT++) {

    let Sp_Value = Sp_RT[I_Sp_RT].split("||>");
    if (I_Sp_RT >= 1 && Sp_Value.length > 1) {


      let Sp_Value_Old = Sp_RT[I_Sp_RT - 1].split("||>");
      if (Sp_Value[0].includes("End")) {
        resolveEndMarker(Sp_RT, I_Sp_RT, Sp_Value, Sp_Value_Old);
      }
      else if (((I_Sp_RT + 1) < Sp_RT.length) && Sp_Value[0].includes("StarAll")) {
        resolveStarAllMarker(Sp_RT, I_Sp_RT, Sp_Value_Old);
      }
    }
    if (I_Sp_RT == Sp_RT.length - 1) {
      _responseText = joinMarkerSegments(Sp_RT);
    }
    _responseText = expandMarkerTokens(_responseText);

  }
  return _responseText;
}

export function finalizeMarkdownEscaping(_responseText) {
  _responseText = _responseText.replace(/(?:\\n\\n|\n\n)/g, "\n");
  _responseText = _responseText.replace(/(?:\\\```|\\```|\```)/g, "<||TextMarkdown||>");

  _responseText = _responseText.replace(/(?:\\\`|\\`)/g, "\\`");

  _responseText = _responseText.replaceAll("<||TextMarkdown||>", "\```");



  _responseText = _responseText.replaceAll("(```", "(\\```");
  _responseText = _responseText.replaceAll("(``", "(\\``");
  _responseText = _responseText.replaceAll("(`", "(\\`");
  _responseText = _responseText.replaceAll("` ` `", "`` ` ``");
  return _responseText;
}
/* eslint-enable no-useless-escape */

export function injectMarkdownStyleScope(_responseText) {
  if (_responseText.indexOf("<!DOCTYPE html>") == 0 && !_responseText.includes("```html\n<!DOCTYPE html>")
    && !_responseText.includes("```\n<!DOCTYPE html>") && _responseText.indexOf("<style>" != -1)) {

    let Sp_responseTextStart = _responseText.split("<style>");
    let Sp_responseTextEnd = Sp_responseTextStart[1].split("</style>");


    if (Sp_responseTextEnd.length > 0) {

      Sp_responseTextEnd[0] = Sp_responseTextEnd[0].replaceAll("}\n", "}\n  #V_markDown ");

    }

    _responseText = Sp_responseTextStart[0] + "<style> #V_markDown " + Sp_responseTextEnd[0] +
      (Sp_responseTextEnd.length > 1 ? " </style> " + Sp_responseTextEnd[1] : "")

  }
  return _responseText;
}
